<div class="property-details-old-info">
  <h2 class="old-info-title dsd-t-5">{{ 'propriete.detail.informations-complementaires.titre' | translate }}</h2>
  <div class="old-info-detail">
    <p *ngIf="currentProperty.titre">
      {{ currentProperty.titre }}
      <button
        (click)="editProperty()"
        id="property-details-old-info-modifier-titre"
        [attr.aria-label]="'propriete.detail.informations-complementaires.modifier-titre' | translate"
      >
        <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
      </button>
    </p>

    <p *ngIf="type">
      {{ type }}
      <button
        (click)="editProperty()"
        id="property-details-old-info-modifier-type"
        [attr.aria-label]="'propriete.detail.informations-complementaires.modifier-type' | translate"
      >
        <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
      </button>
    </p>

    <p *ngIf="currentProperty.proprieteAdresse && currentProperty.proprieteAdresse.adresseFormattee">
      {{ adresse }}
      <button
        (click)="editProperty()"
        id="property-details-old-info-modifier-adresse"
        [attr.aria-label]="'propriete.detail.informations-complementaires.modifier-adresse' | translate"
      >
        <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
      </button>
    </p>

    <p *ngIf="currentProperty.notePersonnelle">
      {{ currentProperty.notePersonnelle }}
      <button
        (click)="editProperty()"
        id="property-details-old-info-modifier-notes-personnelles"
        [attr.aria-label]="'propriete.detail.informations-complementaires.modifier-notes' | translate"
      >
        <img src="{{ 'assets/images/edit.svg' | cheminAbsoluStatique }}" alt="" />
      </button>
    </p>
  </div>
</div>
